export const REQUEST_DURATION_SORT_LABELS = {
  ascLabel: 'Lowest to Highest',
  descLabel: 'Highest to Lowest',
};

export const REQUEST_DATE_SORT_LABELS = {
  ascLabel: 'Oldest To Latest',
  descLabel: 'Latest to Oldest',
};
